(function(){
  var d=document,de=d.documentElement;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  de.classList.add('rm-js');
  var io=null;
  if('IntersectionObserver' in window){
    io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -5% 0px'});
  }
  function reveal(el,i){
    if(el.dataset.rm)return;el.dataset.rm='1';
    el.classList.add('rm-rv');
    el.style.setProperty('--d',((i%3)*0.1)+'s');
    if(io)io.observe(el);else el.classList.add('in');
  }
  function run(){
    var main=d.getElementById('MainContent');if(!main)return;
    var i=0;
    main.querySelectorAll('.shopify-section > *:not(.ap):not(.cf)').forEach(function(el){reveal(el,0);});
    main.querySelectorAll('product-card, .fb, .ap-ptile, .ap-sechead, .cf-info__in, .cf-feat, .cf-card, .cf-more__in > h2').forEach(function(el){reveal(el,i++);});
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',run);else run();
  d.addEventListener('shopify:section:load',run);
})();
